// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./lib/styling/static.css
// module id = 262
// module chunks = 1